import { ROLES } from './enums.js';
export const PERMISSIONS = [
    'customer_view',
    'customer_create_edit',
    'customer_merge',
    'customer_export',
    'customer_erase',
    'prescription_view',
    'prescription_create_version',
    'prescription_print_share',
    'catalogue_view',
    'catalogue_edit',
    'catalogue_bulk_import',
    'cost_price_view',
    'margin_view',
    'price_book_view',
    'price_book_edit_publish',
    'dispense_create',
    'discount_apply_within_limit',
    'discount_apply_above_limit',
    'price_override',
    'payment_take',
    'payment_refund',
    'sale_void',
    'cash_session_open_close',
    'cash_variance_approve',
    'job_create_advance_status',
    'job_quality_check',
    'job_send_to_lab',
    'remake_raise',
    'remake_set_cost_attribution',
    'goodwill_override',
    'repair_intake_complete',
    'loan_frame_issue',
    'stock_view',
    'stock_receive',
    'stock_adjust',
    'stock_transfer_out_in',
    'stocktake_approve_variance',
    'purchase_order_raise',
    'purchase_order_approve',
    'supplier_invoice_match',
    'supplier_invoice_settle',
    'landed_cost_allocate',
    'ledger_view',
    'period_close',
    'accounting_export',
    'expenses_record',
    'promotion_create_edit',
    'margin_floor_override',
    'commission_view_own',
    'commission_view_all_approve',
    'recall_run_campaign',
    'message_send_manual',
    'marketplace_publish_listing',
    'marketplace_handle_dispute',
    'panel_account_manage',
    'claim_capture',
    'panel_remittance_record',
    'report_operational',
    'report_financial',
    'correction_reassign',
    'staff_create_assign_role',
    'staff_offboard',
    'branch_create_close',
    'tenant_settings_policies',
    'subscription_billing',
    'audit_log_view',
];
export const PERMISSION_MATRIX = {
    customer_view: {
        id: 'customer_view',
        label: 'Customer · view',
        sensitive: false,
        roles: ['owner', 'manager', 'dispenser', 'cashier', 'optician', 'accountant', 'read_only'],
    },
    customer_create_edit: {
        id: 'customer_create_edit',
        label: 'Customer · create, edit',
        sensitive: false,
        roles: ['owner', 'manager', 'dispenser', 'cashier', 'optician'],
    },
    customer_merge: {
        id: 'customer_merge',
        label: 'Customer · merge',
        sensitive: false,
        roles: ['owner', 'manager'],
    },
    customer_export: {
        id: 'customer_export',
        label: 'Customer · export',
        sensitive: false,
        roles: ['owner', 'manager', 'accountant'],
    },
    customer_erase: {
        id: 'customer_erase',
        label: 'Customer · erase',
        sensitive: false,
        roles: ['owner'],
    },
    prescription_view: {
        id: 'prescription_view',
        label: 'Prescription · view',
        sensitive: false,
        roles: ['owner', 'manager', 'dispenser', 'cashier', 'optician', 'read_only'],
    },
    prescription_create_version: {
        id: 'prescription_create_version',
        label: 'Prescription · create, version',
        sensitive: false,
        roles: ['owner', 'manager', 'dispenser', 'optician'],
    },
    prescription_print_share: {
        id: 'prescription_print_share',
        label: 'Prescription · print, share',
        sensitive: false,
        roles: ['owner', 'manager', 'dispenser', 'cashier', 'optician'],
    },
    catalogue_view: {
        id: 'catalogue_view',
        label: 'Catalogue · view',
        sensitive: false,
        roles: ['owner', 'manager', 'dispenser', 'cashier', 'optician', 'accountant', 'read_only'],
    },
    catalogue_edit: {
        id: 'catalogue_edit',
        label: 'Catalogue · edit',
        sensitive: false,
        roles: ['owner', 'manager'],
    },
    catalogue_bulk_import: {
        id: 'catalogue_bulk_import',
        label: 'Catalogue · bulk import',
        sensitive: false,
        roles: ['owner', 'manager'],
    },
    cost_price_view: {
        id: 'cost_price_view',
        label: 'Cost price · view',
        sensitive: true,
        roles: ['owner', 'manager', 'accountant'],
    },
    margin_view: {
        id: 'margin_view',
        label: 'Margin · view',
        sensitive: true,
        roles: ['owner', 'manager', 'accountant'],
    },
    price_book_view: {
        id: 'price_book_view',
        label: 'Price book · view',
        sensitive: false,
        roles: ['owner', 'manager', 'dispenser', 'optician', 'accountant', 'read_only'],
    },
    price_book_edit_publish: {
        id: 'price_book_edit_publish',
        label: 'Price book · edit, publish',
        sensitive: false,
        roles: ['owner'],
    },
    dispense_create: {
        id: 'dispense_create',
        label: 'Dispense · create',
        sensitive: false,
        roles: ['owner', 'manager', 'dispenser', 'cashier', 'optician'],
    },
    discount_apply_within_limit: {
        id: 'discount_apply_within_limit',
        label: 'Discount · apply within limit',
        sensitive: true,
        roles: ['owner', 'manager', 'dispenser', 'cashier'],
    },
    discount_apply_above_limit: {
        id: 'discount_apply_above_limit',
        label: 'Discount · apply above limit',
        sensitive: true,
        roles: ['owner', 'manager'],
    },
    price_override: {
        id: 'price_override',
        label: 'Price · override',
        sensitive: true,
        roles: ['owner', 'manager'],
    },
    payment_take: {
        id: 'payment_take',
        label: 'Payment · take',
        sensitive: false,
        roles: ['owner', 'manager', 'dispenser', 'cashier', 'optician'],
    },
    payment_refund: {
        id: 'payment_refund',
        label: 'Payment · refund',
        sensitive: true,
        roles: ['owner', 'manager'],
    },
    sale_void: {
        id: 'sale_void',
        label: 'Sale · void',
        sensitive: true,
        roles: ['owner', 'manager'],
    },
    cash_session_open_close: {
        id: 'cash_session_open_close',
        label: 'Cash session · open, close',
        sensitive: false,
        roles: ['owner', 'manager', 'dispenser', 'cashier'],
    },
    cash_variance_approve: {
        id: 'cash_variance_approve',
        label: 'Cash variance · approve',
        sensitive: true,
        roles: ['owner', 'manager'],
    },
    job_create_advance_status: {
        id: 'job_create_advance_status',
        label: 'Job · create, advance status',
        sensitive: false,
        roles: ['owner', 'manager', 'dispenser', 'optician'],
    },
    job_quality_check: {
        id: 'job_quality_check',
        label: 'Job · quality check',
        sensitive: true,
        roles: ['owner', 'manager', 'optician'],
    },
    job_send_to_lab: {
        id: 'job_send_to_lab',
        label: 'Job · send to lab',
        sensitive: false,
        roles: ['owner', 'manager', 'dispenser', 'optician'],
    },
    remake_raise: {
        id: 'remake_raise',
        label: 'Remake · raise',
        sensitive: false,
        roles: ['owner', 'manager', 'dispenser', 'optician'],
    },
    remake_set_cost_attribution: {
        id: 'remake_set_cost_attribution',
        label: 'Remake · set cost attribution',
        sensitive: true,
        roles: ['owner', 'manager'],
    },
    goodwill_override: {
        id: 'goodwill_override',
        label: 'Goodwill override',
        sensitive: true,
        roles: ['owner', 'manager'],
    },
    repair_intake_complete: {
        id: 'repair_intake_complete',
        label: 'Repair · intake, complete',
        sensitive: false,
        roles: ['owner', 'manager', 'dispenser', 'cashier', 'optician'],
    },
    loan_frame_issue: {
        id: 'loan_frame_issue',
        label: 'Loan frame · issue',
        sensitive: false,
        roles: ['owner', 'manager', 'dispenser', 'optician'],
    },
    stock_view: {
        id: 'stock_view',
        label: 'Stock · view',
        sensitive: false,
        roles: ['owner', 'manager', 'dispenser', 'cashier', 'optician', 'accountant', 'read_only'],
    },
    stock_receive: {
        id: 'stock_receive',
        label: 'Stock · receive',
        sensitive: false,
        roles: ['owner', 'manager', 'dispenser'],
    },
    stock_adjust: {
        id: 'stock_adjust',
        label: 'Stock · adjust',
        sensitive: true,
        roles: ['owner', 'manager'],
    },
    stock_transfer_out_in: {
        id: 'stock_transfer_out_in',
        label: 'Stock · transfer out, in',
        sensitive: false,
        roles: ['owner', 'manager', 'dispenser'],
    },
    stocktake_approve_variance: {
        id: 'stocktake_approve_variance',
        label: 'Stocktake · approve variance',
        sensitive: true,
        roles: ['owner', 'manager'],
    },
    purchase_order_raise: {
        id: 'purchase_order_raise',
        label: 'Purchase order · raise',
        sensitive: false,
        roles: ['owner', 'manager', 'accountant'],
    },
    purchase_order_approve: {
        id: 'purchase_order_approve',
        label: 'Purchase order · approve',
        sensitive: true,
        roles: ['owner', 'manager'],
    },
    supplier_invoice_match: {
        id: 'supplier_invoice_match',
        label: 'Supplier invoice · match',
        sensitive: false,
        roles: ['owner', 'manager', 'accountant'],
    },
    /**
     * `IMP-004`, `decisions/0041`. The 63rd row, added to Appendix B rather than read into an
     * existing one.
     *
     * **Matching is not paying.** `supplier_invoice_match` above is a clerical act: it compares three
     * documents and records a verdict, and no cash moves on it. It does now post a journal, because
     * `decisions/0041`'s missing half landed: entering the invoice books the goods to `inventory` and
     * the obligation to `accounts_payable` under `purchase_invoice`. That is the supplier's own
     * document being recorded rather than a decision to pay, and the obligation exists whether or not
     * anybody writes it down, so the row stays `sensitive: false`. Whether booking a payable belongs
     * in a row that is not sensitive is an Appendix B question, recorded in `../later_todo.md`.
     *
     * Settling an invoice credits cash or the bank and relieves `accounts_payable`, so it is a fraud
     * surface in `ROLE-003`'s sense and carries the bold. Reusing the match row would have given
     * everyone who can tick off a delivery note the ability to record a payment that never happened.
     *
     * Owner, manager and accountant, the same three the match row holds: a shop small enough to have
     * one accountant is a shop where that person pays the suppliers, and Appendix B already trusts
     * them with `landed_cost_allocate` and `accounting_export`.
     */
    supplier_invoice_settle: {
        id: 'supplier_invoice_settle',
        label: 'Supplier invoice · settle',
        sensitive: true,
        roles: ['owner', 'manager', 'accountant'],
    },
    landed_cost_allocate: {
        id: 'landed_cost_allocate',
        label: 'Landed cost · allocate',
        sensitive: true,
        roles: ['owner', 'manager', 'accountant'],
    },
    ledger_view: {
        id: 'ledger_view',
        label: 'Ledger · view',
        sensitive: false,
        roles: ['owner', 'manager', 'accountant', 'read_only'],
    },
    period_close: {
        id: 'period_close',
        label: 'Period · close',
        sensitive: true,
        roles: ['owner', 'accountant'],
    },
    accounting_export: {
        id: 'accounting_export',
        label: 'Accounting · export',
        sensitive: true,
        roles: ['owner', 'manager', 'accountant'],
    },
    expenses_record: {
        id: 'expenses_record',
        label: 'Expenses · record',
        sensitive: false,
        roles: ['owner', 'manager', 'cashier', 'accountant'],
    },
    promotion_create_edit: {
        id: 'promotion_create_edit',
        label: 'Promotion · create, edit',
        sensitive: false,
        roles: ['owner', 'manager'],
    },
    margin_floor_override: {
        id: 'margin_floor_override',
        label: 'Margin floor · override',
        sensitive: true,
        roles: ['owner', 'manager'],
    },
    commission_view_own: {
        id: 'commission_view_own',
        label: 'Commission · view own',
        sensitive: false,
        roles: ['owner', 'manager', 'dispenser', 'cashier', 'optician', 'accountant'],
    },
    commission_view_all_approve: {
        id: 'commission_view_all_approve',
        label: 'Commission · view all, approve',
        sensitive: true,
        roles: ['owner', 'accountant'],
    },
    recall_run_campaign: {
        id: 'recall_run_campaign',
        label: 'Recall · run campaign',
        sensitive: false,
        roles: ['owner', 'manager', 'dispenser'],
    },
    message_send_manual: {
        id: 'message_send_manual',
        label: 'Message · send manual',
        sensitive: false,
        roles: ['owner', 'manager', 'dispenser', 'cashier', 'optician'],
    },
    marketplace_publish_listing: {
        id: 'marketplace_publish_listing',
        label: 'Marketplace · publish listing',
        sensitive: false,
        roles: ['owner', 'manager'],
        outOfV1: true,
    },
    marketplace_handle_dispute: {
        id: 'marketplace_handle_dispute',
        label: 'Marketplace · handle dispute',
        sensitive: false,
        roles: ['owner', 'manager'],
        outOfV1: true,
    },
    /**
     * §6.13 `CLM-001`: panel and corporate accounts, their plans and their coverage rules.
     * `OPEN.md` 4.5, `later_todo.md` 99.
     *
     * **Shop setup, so owner and manager.** A panel is a commercial agreement with a payer: which
     * plans exist, what each covers and what the shop may bill for. It is a price list's neighbour,
     * and `catalogue_edit` and `tenant_settings_policies` are both held by the same two.
     *
     * Not sensitive. Nothing here moves money or reveals a cost; what a panel covers is the shop's
     * own commercial terms, and `ROLE-003`'s bold marks the fraud surfaces.
     */
    panel_account_manage: {
        id: 'panel_account_manage',
        label: 'Panel account · manage',
        sensitive: false,
        roles: ['owner', 'manager'],
    },
    /**
     * §6.13 `CLM-002`, `CLM-003`: splitting a sale line between the payer and the customer.
     *
     * **The wide row, because it happens while serving a customer.** Whoever is at the counter does
     * this, so it is held by the same five as `prescription_print_share` and
     * `customer_create_edit`: a dispenser who cannot capture a claim cannot complete a panel
     * customer's sale, which makes the feature unusable in the shop it was written for.
     *
     * Not sensitive. §15.20 step 3 is explicit that a panel's share is "a receivable, not a
     * payment", so capture records what is owed and tenders nothing. Recording that the payer
     * actually paid is `panel_remittance_record` below, and that one is bold.
     */
    claim_capture: {
        id: 'claim_capture',
        label: 'Claim · capture',
        sensitive: false,
        roles: ['owner', 'manager', 'dispenser', 'cashier', 'optician'],
    },
    /**
     * §6.13 `CLM-004`, §15.20 step 5: money a panel paid, spread across its claims, and the
     * compensating row when a cheque comes back.
     *
     * **Money arriving and being attributed, so it is bold and narrow.** A remittance decides which
     * claims are settled, which is the same authority as `supplier_invoice_settle` pointing the
     * other way, and it is the posting that would relieve `insurance_receivable`
     * (`later_todo.md` 98). Owner, manager and accountant, the three that hold every other row where
     * cash is reconciled.
     *
     * **Deliberately not `claim_capture` and not `report_financial`.** A dispenser who splits a claim
     * at the counter must not be able to record that the panel paid; and reading what a panel owes,
     * which is the statement, is not the authority to write what it paid.
     */
    panel_remittance_record: {
        id: 'panel_remittance_record',
        label: 'Panel remittance · record',
        sensitive: true,
        roles: ['owner', 'manager', 'accountant'],
    },
    report_operational: {
        id: 'report_operational',
        label: 'Report · operational',
        sensitive: false,
        roles: ['owner', 'manager', 'dispenser', 'cashier', 'optician', 'accountant', 'read_only'],
    },
    report_financial: {
        id: 'report_financial',
        label: 'Report · financial',
        sensitive: true,
        roles: ['owner', 'manager', 'accountant'],
    },
    correction_reassign: {
        id: 'correction_reassign',
        label: 'Correction · reassign',
        sensitive: true,
        roles: ['owner', 'manager'],
    },
    staff_create_assign_role: {
        id: 'staff_create_assign_role',
        label: 'Staff · create, assign role',
        sensitive: false,
        roles: ['owner', 'manager'],
    },
    staff_offboard: {
        id: 'staff_offboard',
        label: 'Staff · offboard',
        sensitive: true,
        roles: ['owner'],
        outOfV1: true,
    },
    branch_create_close: {
        id: 'branch_create_close',
        label: 'Branch · create, close',
        sensitive: false,
        roles: ['owner'],
    },
    tenant_settings_policies: {
        id: 'tenant_settings_policies',
        label: 'Tenant settings, policies',
        sensitive: true,
        roles: ['owner'],
    },
    subscription_billing: {
        id: 'subscription_billing',
        label: 'Subscription, billing',
        sensitive: true,
        roles: ['owner'],
    },
    audit_log_view: {
        id: 'audit_log_view',
        label: 'Audit log · view',
        sensitive: false,
        roles: ['owner', 'manager'],
    },
};
/**
 * Whether a role holds a permission.
 *
 * Deliberately not the whole authorisation question. See the note above: branch membership and the
 * cost-visibility grant are separate checks, and a caller that only asks this one has answered
 * "may a manager do this" rather than "may this manager do this here".
 */
export function can(role, permission) {
    return PERMISSION_MATRIX[permission]?.roles.includes(role) ?? false;
}
/**
 * `ROLE-001a` and `BR-12`. Cost-price and margin visibility needs the role AND the per-branch grant,
 * which defaults to not granted, because "a branch manager seeing group buying prices is a
 * commercial leak".
 */
export function canSeeCostPrice(role, permission, grantedBranches, branchId) {
    return can(role, permission) && grantedBranches.includes(branchId);
}
/** `ROLE-001`: the role says what, the branch list says where. */
export function canActAt(branches, branchId) {
    return branches.includes(branchId);
}
/**
 * Whether one role may create another. `ROLE-002`, `TEN-002a`, Appendix B.
 *
 * **Appendix B grants `Staff - create, assign role` to the owner and the manager and does not say
 * which roles either may assign.** Read literally that lets a manager create an owner, which hands
 * them `Staff - offboard` and `Branch - create, close` indirectly, the two rows the matrix
 * deliberately denies them. A permission you cannot use yourself but can grant to an account you
 * control is the same permission.
 *
 * So the rule is read off the matrix rather than chosen: a role may be assigned only if everything
 * it can do, the assigner can already do. That is exactly "no escalation", it needs no new list to
 * keep in step with Appendix B, and it answers the only question the row leaves open without
 * inventing a hierarchy the spec does not state.
 *
 * It is not a total order: two roles with overlapping but unequal permissions can each be unable to
 * create the other, which is the honest answer for them.
 */
export function mayAssignRole(assigner, assigned) {
    return PERMISSIONS.every((permission) => !can(assigned, permission) || can(assigner, permission));
}
/** The roles this one may create, for a screen that offers a chooser rather than a refusal. */
export function assignableRoles(assigner) {
    return ROLES.filter((role) => mayAssignRole(assigner, role));
}
/** The `ROLE-003` fraud, privacy and margin surfaces. Every use of these is audited. */
export function sensitivePermissions() {
    return PERMISSIONS.filter((p) => PERMISSION_MATRIX[p].sensitive);
}
//# sourceMappingURL=permissions.js.map